import { BackgroundCheckConfig } from '../defaults';
import { BackgroundCheckType } from '../types';

export const getEnabledBackgroundCheckTypes = (backgroundCheckConfig?: BackgroundCheckConfig): BackgroundCheckType[] =>
    backgroundCheckConfig?.type
        ? Object.entries(backgroundCheckConfig?.type).reduce((acc, [type, value]) => {
              if (value.enabled) {
                  acc.push(type as BackgroundCheckType);
              }

              return acc;
          }, [] as BackgroundCheckType[])
        : [];
